// @flow
import { map } from 'ramda';

import ActionTypes from './action-types';
import type { ActivityProfileAction, DateProfile } from './sagas';

export type ProfileItem = {
  id: string,
  value: number,
  percentage: number,
};

export type ProfileState = {
  dateProfile: ProfileItem[],
  dateProfileTask: ProfileItem[],
  dateProfileLoading: boolean | null,
};

const initialState: ProfileState = {
  dateProfileLoading: null,
  dateProfile: [],
  dateProfileTask: [],
};

const formatData: Function = function formatData(data: DateProfile): ProfileItem[] {
  return map((key: string): ProfileItem => (
    {
      id: key,
      value: data[key].value,
      percentage: data[key].percentage,
    }
  ), Object.keys(data));
};

type Exact<T> = T & $Shape<T>; // https://github.com/facebook/flow/issues/2405

export default function (state: ProfileState = initialState, action: ActivityProfileAction): Exact<ProfileState> {
  let dp: ProfileItem[];

  switch (action.type) {
    case ActionTypes.GET_DATE_PROFILE_SUCCESS:
      dp = formatData(action.data.activities);
      return {
        ...state,
        dateProfile: dp,
        dateProfileLoading: false,
      };
    case ActionTypes.GET_DATE_PROFILE_TASK_SUCCESS:
      dp = formatData(action.data.tasks);
      return {
        ...state,
        dateProfileTask: dp,
      };
    default:
      return state;
  }
}
